// extracted by mini-css-extract-plugin
export default {"root":"TableBody-root-1139ad78db6ecaf366a1f86c363b06a7"};